<template>
  <el-dialog
    class="CreateTaskForm"
    ref="dialog"
    :visible.sync="visible"
    @update:visible="$emit('update:visible', $event)"
    @closed="closed"
    append-to-body
    center
    :title="title"
    width="900px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <ele-form
      :isShowCancelBtn="false"
      :isResponsive="false"
      :isShowSubmitBtn="true"
      :isShowBackBtn="false"
      submitBtnText="发 送"
      cancelBtnText="取 消"
      labelPosition="right"
      :formDesc="formDesc"
      v-model="formData"
      :request-fn="handleRequest"
      ref="flowForm"
      @request-success="handleRequestSuccess"
    ></ele-form>
  </el-dialog>
</template>

<script>
import _ from "lodash";
import comps from "ayb-form-design/src/helpers/comps";
import tool from "ayb-form-design/src/helpers/form";
import { GetTableList } from "ayb-form-design/src/api/databaseTable.js";
import { GetFormData } from "ayb-form-design/src/api/custmerForm.js"; //GetSchemeEntity
import { SaveTableData } from "ayb-form-design/src/api/databaseTable.js";
import { Flow } from "ayb-form-design/src/api/WfEngine.js";
import { GetSchemeData } from "ayb-form-design/src/api/WFScheme.js";
import formTool from "ayb-form-design/src/helpers/form";

import { InsertBaseTask } from "@/api/modules/basicData/basicTask";
import { mapState } from "vuex";
// import { delete } from 'vue/types/umd';
export default {
  name: "CreateFlowForm",
  data() {
    return {
      formInfo: null,
      visible: false,
      title: "",
      formData: {},
      formDesc: {},
      oldFormDesc: {},
      formItemList: [],
      formAttr: {},
      currentScheme: {},
      dbTable: {},
      ApprovalInfo: {}, //审批节点及审批人,
      node: {},
      typeInfo: {}, //任务类型
      comps: comps,
      formBtns: [
        {
          text: "取 消",
          attrs: {
            type: "primary",
          },
          click: this.cancel,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userId: (state) => state.task.userId,
      ServerCenterIds: (state) => state.task.ServerCenterIds,
      createIdentity: (state) => state.task.createIdentity,
      contactId: (state) => state.user.ContactID,
      realName: (state) => state.task.realName,
      departmentId: (state) => state.user.departmentId,
      departmentName: (state) => state.user.departmentName,
      companyId: (state) => state.user.organizationId,
      companyName: (state) => state.user.organizationName,
    }),
  },
  methods: {
    closed() {
      this.formDesc = {};
      this.formData = {};
    },
    async openDialog(formDesc,formData) {
        this.formInfo = formData;
        this.visible=true;
        setTimeout(()=> {
            this.formDesc = formDesc;
        }, 0);
    },
    cancel() {
      this.visible = false;
    },
    TimeFormat(time) {
      if(time){
        var newTime = new Date(time);

        function HaveZero(t) {
          return t < 10 ? "0" + t : t;
        }
        var year = newTime.getFullYear();
        var month = HaveZero(newTime.getMonth() + 1);
        var day = HaveZero(newTime.getDate());
        var hours = HaveZero(newTime.getHours());
        var min = HaveZero(newTime.getMinutes());
        var sec = HaveZero(newTime.getSeconds());
        return `${year}-${month}-${day}T${hours}:${min}:${sec}`;
      }else{
        return "";
      }
    },
    Guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    async handleRequest(data) {
      console.log("handleRequest",data);
        this.$emit("success", this.formInfo, data);
        // this.visible = false;
      // console.log("新的表单数据", data);
      return Promise.resolve(data);
    },
    handleRequestSuccess() {
      // this.$message.success("发送成功");
    },
  },
};
</script>
<style scoped>
.CreateTaskForm >>> .ele-form-btns {
  text-align: center;
}
.CreateTaskForm >>> .el-dialog__header {
  text-align: left;
}
</style>
<style lang="less" scoped>
.CreateTaskForm {
  /deep/ .el-dialog__footer {
    padding: 0px 20px 5px 0px;
  }

  /deep/ .el-dialog {
    margin: 0 auto 0px;
  }

  /deep/ .el-dialog__body {
    padding: 0px 5px;
    overflow-y: auto;
  }


  /deep/ .el-col {
    margin-top: 0px;
    // padding-right: 20px;
    padding-left: 10px;
  }
}
</style>